module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2022-10-18 at 11.39.04 AM.d47cb062.jpeg";